(function () {
  var started = false;

  function formatEUR(amount) {
    var formatted = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    return '€' + formatted;
  }

  function apply(card, amount) {
    var priceWrap = card.querySelector('.price');
    if (priceWrap) priceWrap.setAttribute('hidden', 'hidden');

    var box = card.querySelector('.fcsm-current-bid');
    if (!box || !box.querySelector('.fcsm-current-bid__amount')) {
      if (box) box.remove();
      box = document.createElement('div');
      box.className = 'fcsm-current-bid';
      box.innerHTML = '<span class="fcsm-current-bid__label">Enchère actuelle</span><span class="fcsm-current-bid__amount"></span>';
      if (priceWrap) priceWrap.before(box);
      else return;
    }

    box.querySelector('.fcsm-current-bid__amount').textContent = formatEUR(amount);
  }

  function amountFromHistory(history) {
    if (!history) return null;
    if (history.currentAmount != null && history.currentAmount !== '') {
      return Number(history.currentAmount);
    }
    if (history.amount != null && history.amount !== '') {
      return Number(history.amount);
    }
    return null;
  }

  function auctionFor(productId) {
    var auctions = (window.Tipo.Auction && window.Tipo.Auction.auctions) || [];
    for (var i = 0; i < auctions.length; i++) {
      var auction = auctions[i];
      var rule = auction.config && auction.config.rule;
      if (!rule) continue;
      if (rule.all && rule.all.enabled) return auction;
      if (rule.manual && rule.manual.enabled) {
        var ids = rule.manual.ids || [];
        for (var j = 0; j < ids.length; j++) {
          if (String(ids[j]) === String(productId)) return auction;
        }
      }
    }
    return null;
  }

  function run() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('.tipo-auction-collection[data-id]')
    ).filter(function (node) {
      return auctionFor(node.dataset.id);
    });
    if (!nodes.length || !window.Tipo || !window.Tipo.Auction) return;

    var auction = auctionFor(nodes[0].dataset.id);
    if (!auction) return;

    var start = Number(auction.config && auction.config.startPrice) || 0;
    var ids = nodes.map(function (node) {
      return node.dataset.id;
    });
    var params = new URLSearchParams({
      productIds: ids.join(','),
      profileIds: String(auction.id)
    });

    fetch('/apps/auction/customer/summaries?' + params.toString(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var histories = (data && (data.histories || data.summaries)) || [];
        var byProduct = {};
        histories.forEach(function (history) {
          var amount = amountFromHistory(history);
          if (amount == null || Number.isNaN(amount)) return;
          byProduct[String(history.product_id)] = amount;
        });

        nodes.forEach(function (node) {
          var card = node.closest('.card-wrapper') || node.parentElement;
          if (!card) return;
          var amount =
            byProduct[node.dataset.id] != null ? byProduct[node.dataset.id] : start;
          apply(card, amount);
        });
      })
      .catch(function () {
        nodes.forEach(function (node) {
          var card = node.closest('.card-wrapper') || node.parentElement;
          if (!card) return;
          apply(card, start);
        });
      });
  }

  function boot(tries) {
    if (
      window.Tipo &&
      window.Tipo.Auction &&
      window.Tipo.Auction.auctions &&
      window.Tipo.Auction.auctions.length
    ) {
      if (!started) {
        started = true;
        var grid = document.querySelector('.collection-product-list');
        if (grid && window.MutationObserver) {
          var timer;
          new MutationObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(run, 200);
          }).observe(grid, { childList: true });
        }
        setInterval(run, 30000);
      }
      run();
      return;
    }
    if (tries < 20) setTimeout(function () { boot(tries + 1); }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(0); });
  } else {
    boot(0);
  }
})();
